/* eslint-disable no-shadow */
/* eslint-disable complexity */
import React, { Fragment, useRef, useEffect } from "react";
import styles from "./styles/index.css";
import PropTypes from "prop-types";
import scrollToView from "../../../utils/helpers/scroll-to-view";
import ArrowBack from "./images/arrow-back.svg";
import ArrowRightIcon from "./images/arrow-right.svg";

const VARIANT_STYLES = {
    primary: "styles.btn-primary",
    secondary: "styles.btn-secondary",
    tertiary: "styles.btn-tertiary",
    descriptive: "styles.btn-descriptive",
    black: "styles.btn-black",
    translucent: "styles.btn-translucent",
    white: "styles.btn-white"
};

const LINK_BUTTON_VARIANT_STYLES = {
    primary: "styles.link-btn-primary",
    secondary: "styles.link-btn-secondary",
    tertiary: "styles.link-btn-tertiary",
    descriptive: "styles.link-btn-descriptive",
    black: "styles.link-btn-black",
    translucent: "styles.link-btn-translucent",
    white: "styles.link-btn-white"
};

const SIZE_STYLES = {
    xsmall: "styles.btn-xsmall",
    small: "styles.btn-small",
    medium: "styles.btn-medium",
    large: "styles.btn-large"
};

const SPINNER_VARIANT_STYLES = {
    primary: "styles.spinner-primary",
    secondary: "styles.spinner-secondary",
    tertiary: "styles.spinner-tertiary",
    descriptive: "styles.spinner-descriptive",
    black: "styles.spinner-black",
    translucent: "styles.spinner-translucent",
    white: "styles.spinner-white"
};

const SPINNER_SIZE_STYLES = {
    xsmall: "styles.spinner-xsmall",
    small: "styles.spinner-small",
    medium: "styles.spinner-medium",
    large: "styles.spinner-large"
};
const Button = (props) => {
    const {
        variant = "primary",
        size = "large",
        onClick,
        id = "",
        rupee = null,
        dataTitle = "",
        text = "",
        loadingText = "",
        transparent = false,
        disabled = false,
        rightImage = null,
        leftImage = null,
        customStyle = [],
        customClass = "",
        isLoading = false,
        scrollTop,
        type = "button",
        handleClick,
        customDisabled = false,
        showArrow = false,
        showColoredArrow = false,
        isUpperCase = false,
        ...restProps
    } = props;
    const effectiveLoadingText = loadingText || text || "Loading...";

    const getButtonStyleName = ({
        variant,
        size,
        disabled,
        customDisabled,
        customStyle,
        isUpperCase,
        buttonType,
        transparent
    }) => {
        const isLinkButton = buttonType === "link_button";
        const variantStyle = isLinkButton
            ? (LINK_BUTTON_VARIANT_STYLES[variant] || LINK_BUTTON_VARIANT_STYLES.primary)
            : (VARIANT_STYLES[variant] || VARIANT_STYLES.primary);

        return [
            "styles.common-btn",
            "styles.btn-styles",
            isLinkButton && "styles.link-btn-base",

            // variant
            variantStyle,

            // transparent modifier
            transparent && "styles.btn-transparent",

            // size
            SIZE_STYLES[size] || SIZE_STYLES.medium,

            // states
            (disabled || customDisabled) && "styles.disable-btn",
            isLoading && "styles.loading-btn",
            isUpperCase && "styles.uppercase",

            // overrides (escape hatch)
            ...(customStyle || []).map(item => `styles.${item}`)
        ]
            .filter(Boolean)
            .join(" ");
    };

    const getSpinnerStyleName = ({ variant, size, isLoading }) => {
        if (!isLoading) return "";

        return [
            "styles.spinner",
            SPINNER_VARIANT_STYLES[variant] || SPINNER_VARIANT_STYLES.primary,
            SPINNER_SIZE_STYLES[size] || SPINNER_SIZE_STYLES.medium
        ]
            .filter(Boolean)
            .join(" ");
    };

    const ref = useRef();

    useEffect(() => {
        if (scrollTop) {
            window.setTimeout(() => {
                scrollToView(ref.current);
            }, 0);
        }
    }, [scrollTop]);
    const styleName = getButtonStyleName({
        variant,
        size,
        disabled,
        customDisabled,
        customStyle,
        isUpperCase,
        buttonType: type,
        transparent
    });

    return (
        <Fragment>
            <button ref={ref} id={id} data-title={dataTitle}
                disabled={disabled || isLoading} onClick={onClick || handleClick}
                type={type} className={`btn ${customClass}`}
                styleName={styleName}
                {...restProps}
            >
                {
                    isLoading && !disabled ? <>
                        <i className="spinnerBtn"
                            styleName={getSpinnerStyleName({ variant, size, isLoading })}
                        /> {effectiveLoadingText}
                    </> :
                        <>
                            {leftImage && <img styleName={"styles.img-left"} src={leftImage} />}
                            {text} {rightImage && <img styleName={"styles.img-right"} src={rightImage} />}
                            {rupee && <span>{rupee}</span>}

                            {(showArrow && !isLoading) && <img styleName={"styles.arrow-img"} src={ArrowBack} />}
                        </>
                }
                {(showColoredArrow && !isLoading) && <img styleName={"styles.arrow-img"} src={ArrowRightIcon} />}
            </button>
        </Fragment>
    );
};

Button.propTypes = {
    variant: PropTypes.oneOf([
        "primary",
        "secondary",
        "tertiary",
        "descriptive",
        "black",
        "translucent",
        "white"
    ]),
    size: PropTypes.oneOf(["xsmall", "small", "medium", "large"]),
    onClick: PropTypes.func,
    id: PropTypes.string,
    rupee: PropTypes.any,
    dataTitle: PropTypes.string,
    text: PropTypes.string,
    transparent: PropTypes.bool,
    disabled: PropTypes.bool,
    rightImage: PropTypes.any,
    leftImage: PropTypes.any,
    customStyle: PropTypes.array,
    customClass: PropTypes.string,
    isLoading: PropTypes.bool,
    scrollTop: PropTypes.bool,
    hideLoader: PropTypes.bool,
    type: PropTypes.string,
    btnView: PropTypes.string,
    handleClick: PropTypes.func,
    customDisabled: PropTypes.func,
    showArrow: PropTypes.bool,
    showColoredArrow: PropTypes.bool,
    loadingText: PropTypes.string,
    isUpperCase: PropTypes.bool
};

export default Button;
